import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export const formatStatus = (status: string) => {
  const statusOptions = {
    'active': 'Active',
    'completed': 'Completed',
    'inactive': 'Inactive'
  }
  return statusOptions[status as keyof typeof statusOptions] || status;
}
